<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Shipping Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      
    </section>

    <section id="dashboard_summary" v-if="summaryData" style="width:625px; margin:0 auto;">
      <vue-good-table 
        :rows="summaryData"
        :name="'dash_summary'"
        :sort-options="{
          enabled: false,
        }"
        :columns="[
          {
            label: '',
            field: 'category',
            type: 'text',
            thClass: 'col_category',
            tdClass: 'col_category',
          },
          {
            label: 'Pick',
            field: 'pick',
            type: 'text',
            formatFn: format_numbers,
          },
          {
            label: 'Pack',
            field: 'pack',
            type: 'text',
            formatFn: format_numbers,
          },
          {
            label: 'Docs',
            field: 'docs',
            type: 'text',
            formatFn: format_numbers,
          },
          {
            label: 'Ship',
            field: 'ship',
            type: 'text',
            formatFn: format_numbers,
          },

        ]"
      >
          <template v-slot:table-row="props">
            <span v-if="props.column.field == 'category'">
              <span v-if="props.row.category != 'Count'"
               style="font-size:0.5em; font-weight:normal;">
                (avg min)
              </span>
              <span style="font-weight: bold; color: #606266; width:100%">
                {{props.row.category}}
              </span> 
              
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
      </vue-good-table>
    </section>

    <div style="width:100%; height:2em;"></div>

    <section id="dashboard_detail" v-if="detailData">
      <vue-good-table 
        :rows="detailData"
        :name="'dash_detail'"
        :sort-options="{
          enabled: false,
        }"
        :columns="[
          {
            label: 'Ship Order',
            field: 'sm_number',
            type: 'text',
          },
          {
            label: 'Entry Date',
            field: 'entry_date',
            type: 'text',
          },
          {
            label: 'Status',
            field: 'status_code',
            type: 'text',
          },
          {
            label: 'Created By',
            field: 'created_by',
            type: 'text',
          },
          {
            label: 'Assigned To',
            field: 'assigned_to',
            type: 'text',
          },
          {
            label: 'Priority',
            field: 'priority',
            type: 'text',
          },
          {
            label: 'Updated',
            field: 'sms_update',
            type: 'text',
            formatFn: function(value) {if(value == null){return value};return value.split('T')[0]},
          },
          {
            label: 'Items',
            field: 'number_of_items',
            type: 'text',
          },
          {
            label: 'Customer',
            field: 'company_name',
            type: 'text',
          },
          {
            label: 'Ship Via',
            field: 'ship_via_code',
            type: 'text',
          },
          {
            label: 'Site',
            field: 'site_description',
            type: 'text',
          },
          {
            label: 'SO #',
            field: 'so_number',
            type: 'text',
          },
        ]"
      />
    </section>

    
  </div>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
  }

  .site{
    font-size: 2em;
  }

  
</style>

<style>
  .col_category{
    background:#f1f3f6;
    
  }
  .vgt-table thead th.col_category{
    background:white;
    border-top: 1px solid white;
    border-left: 1px solid white;
  }
  #dashboard_summary .vgt-table{
    font-size: 1.3em;
  }
</style>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import moment from 'moment';
import {
  DASHBOARD_SHIPPING
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardShipping',
  components: {
    VueGoodTable,
    HeroContainer,
  },
  computed:{
    summaryData(){
      if (Object.prototype.hasOwnProperty.call(this.queryDataRaw, 'summary')){
        return this.queryDataRaw.summary
      }
      return {}
    },
    personData(){
      if (Object.prototype.hasOwnProperty.call(this.queryDataRaw, 'person')){
        return this.queryDataRaw.person
      }
      return {}
    },
    detailData(){
      if (Object.prototype.hasOwnProperty.call(this.queryDataRaw, 'detail')){
        return this.queryDataRaw.detail
      }
      return {}
    },
  },
  data: function(){
    return {
      numeral: require('numeral'),
      part_number: '',
      price_difference_low: '',
      price_difference_high: '',
      percent_difference_low: '',
      percent_difference_high: '',
      date_range: 'week',
      range: [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ],
      queryDataRaw: {},
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  methods: {
    reset(){
      this.part_number = ''
      this.price_difference_low = ''
      this.price_difference_high = ''
      this.percent_difference_low = ''
      this.percent_difference_high = ''
      this.date_range=  'week'
      this.range = [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ]
    },
    format_numbers(value){
      if(value == null){
        return value
      }
      let fixed = value.toFixed(1)
      let split = fixed.split('.')
      if (split[1]=='0'){
        return split[0]
      } else{  
        return fixed
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    ajax_get_dashboard(){
      let url = DASHBOARD_SHIPPING
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'GET'
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        // eslint-disable-next-line no-console
        console.error(JSON.stringify(e.message));
      });
      // refresh every x minutes
      setTimeout(this.ajax_get_dashboard, 5*60000)
    },
  }
};

</script>
